import { useState, useEffect } from "react";
import { Col, Row, Container, Badge } from "react-bootstrap";
import Moment from "react-moment";

// APIs
import { openweathermapKey, weatherApiKey } from "../shared/API";

// components
import Search from "./SearchComponent";
import Promotion from "./PromotionComponent";
import "./styles/componentStyles.css";

// tabs components
import NowTab from "./Tabs/NowTabComponent";
import HourlyTab from "./Tabs/HourlyTabComponent";
import DailyTab from "./Tabs/DailyTabComponent";
import AirqualityTab from "./Tabs/AirqualityTabComponent";
// import RadarTab from './Tabs/RadarTabComponent';
// import NewsTab from './Tabs/NewsTabComponent';
import AlertsTab from "./Tabs/AlertsTabComponents";
import { VideoClip } from "./VideoComponent";

export default function Home() {
    const days = {
        default: "videos/SunnyDay.mp4",
        rain: "videos/Rain.mp4",
        mist: "videos/Mist.mp4",
        snow: "videos/Snow.mp4",
        cloud: "videos/Clouds.mp4",
    };

    //   const [icon, setIcon] = useState<string>("icons/01d.svg");
    const [ok, setOk] = useState(false);
    const [coords, setCoords] = useState<number[]>([28.6139, 77.209]); // format longitute, latitude
    const [location, setLocation] = useState("New Delhi, India");
    const [day, setDay] = useState<any>(days.default);
    const [data, setData] = useState<any>("");
    const [date, setDate] = useState<number>();
    const [alertData, setAlertData] = useState<any>([]);
    const [airData, setAirData] = useState();
    // tabs
    const [isNowActive, setIsNowActive] = useState(true);
    const [isHourlyActive, setIsHourlyActive] = useState(false);
    const [isDailyActive, setIsDailyActive] = useState(false);
    const [isAirqualityActive, setIsAirqualityActive] = useState(false);
    // // const [isRadarActive, setIsRadarActive] = useState(false);
    // // const [isNewsActive, setIsNewsActive] = useState(false);
    const [isAlertsActive, setIsAlertsActive] = useState(false);

    useEffect(() => {
        const url = `https://api.openweathermap.org/data/3.0/onecall?units=metric&lat=${coords[0]}&lon=${coords[1]}&appid=${openweathermapKey}`;
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);

                setData(data);
                setOk(true);
                const weatherId = data.current.weather[0].id;

                if (weatherId >= 801 && weatherId < 900) setDay(days.cloud);
                else if (weatherId >= 700 && weatherId < 800) setDay(days.mist);
                else if (weatherId >= 600 && weatherId < 700) setDay(days.snow);
                else if (weatherId >= 300 && weatherId < 400) setDay(days.rain);
                else if (weatherId >= 500 && weatherId < 600) setDay(days.rain);
                else if (weatherId >= 200 && weatherId < 300) setDay(days.rain);
                else setDay(days.default);
                setDate(data.current.dt);
            });

        fetch(
            `https://api.openweathermap.org/data/2.5/air_pollution?lat=${coords[0]}&lon=${coords[1]}&appid=${openweathermapKey}`
        )
            .then((response) => response.json())
            .then((data) => {
                setAirData(data);
            });
        fetch(`https://api.weatherapi.com/v1/forecast.json?key=${weatherApiKey}&q=${location}&days=1&aqi=no&alerts=yes`)
            .then((response) => response.json())
            .then((data) => {
                setAlertData(data.alerts.alert);
            });
    }, [location, coords]);

    const handleActive = (tabName: string) => {
        if (tabName === "airquality") {
            setIsAirqualityActive(true);
            setIsAlertsActive(false);
            setIsDailyActive(false);
            setIsHourlyActive(false);
            // setIsRadarActive(false);
            setIsNowActive(false);
            // setIsNewsActive(false);
        } else if (tabName === "alert") {
            setIsAirqualityActive(false);
            setIsAlertsActive(true);
            setIsDailyActive(false);
            setIsHourlyActive(false);
            // setIsRadarActive(false);
            setIsNowActive(false);
            // setIsNewsActive(false);
        } else if (tabName === "daily") {
            setIsAirqualityActive(false);
            setIsAlertsActive(false);
            setIsDailyActive(true);
            setIsHourlyActive(false);
            // setIsRadarActive(false);
            setIsNowActive(false);
            // setIsNewsActive(false);
        } else if (tabName === "hourly") {
            setIsAirqualityActive(false);
            setIsAlertsActive(false);
            setIsDailyActive(false);
            setIsHourlyActive(true);
            // setIsRadarActive(false);
            setIsNowActive(false);
            // setIsNewsActive(false);
            // }else if(tabName === "radar"){
            // setIsAirqualityActive(false);
            // setIsAlertsActive(false);
            // setIsDailyActive(false);
            // setIsHourlyActive(false);
            // // setIsRadarActive(true);
            // setIsNowActive(false);
            // // setIsNewsActive(false);
        } else if (tabName === "monthly") {
            setIsAirqualityActive(false);
            setIsAlertsActive(false);
            setIsDailyActive(false);
            setIsHourlyActive(false);
            // setIsRadarActive(false);
            setIsNowActive(false);
            // setIsNewsActive(false);
        } else if (tabName === "now") {
            setIsAirqualityActive(false);
            setIsAlertsActive(false);
            setIsDailyActive(false);
            setIsHourlyActive(false);
            // setIsRadarActive(false);
            setIsNowActive(true);
            // setIsNewsActive(false);
            // }else if(tabName === "news"){
            // setIsAirqualityActive(false);
            // setIsAlertsActive(false);
            // setIsDailyActive(false);
            // setIsHourlyActive(false);
            // setIsRadarActive(false);
            // setIsNowActive(false);
            // setIsNewsActive(true);
        }
    };
    //   console.log("day", day);

    return (
        <div className="weather-video">
            {<VideoClip url={days.default} />}
            {day === days.mist ? <VideoClip url={days.mist} /> : <></>}
            {day === days.cloud ? <VideoClip url={days.cloud} /> : <></>}
            {day === days.rain ? <VideoClip url={days.rain} /> : <></>}
            {day === days.snow ? <VideoClip url={days.snow} /> : <></>}

            <Row noGutters={true}>
                <Col sm={5}>
                    <Promotion />
                </Col>
                <Col sm={7}>
                    <Search
                        onChangeInput={(value: string) => setLocation(value)}
                        onChangeLocation={(value: any) => setCoords(value)}
                    />
                </Col>
            </Row>
            <div>
                <Container style={{ marginTop: "20px" }}>
                    {ok ? (
                        <Container style={{ color: "floralwhite" }}>
                            <br />
                            <h2> {location} </h2>
                            <p>
                                {" "}
                                Latitude: {data.lat}, Longitude: {data.lon}
                            </p>
                            <p>
                                {" "}
                                <Moment unix>{date}</Moment> ( {data.timezone} ){" "}
                            </p>

                            <Row style={{ marginLeft: "15px" }}>
                                <img
                                    className="major-icons"
                                    src={`http://openweathermap.org/img/w/${data.current.weather[0].icon}.png`}
                                    alt=""
                                />
                                <Col style={{ marginLeft: "15px" }}>
                                    <h2> Current Temperature: {data.current.temp} °C</h2>
                                    <div>
                                        <p> Feels like</p>
                                        <h3 style={{ marginTop: "-10px" }}> {data.current.feels_like} °C</h3>{" "}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    ) : (
                        <div></div>
                    )}
                    <hr />
                    <div style={{ zIndex: 0 }} className="container mt-1 ml-1">
                        <Row>
                            <div className="tab-btn" onClick={() => handleActive("now")}>
                                {" "}
                                Now{" "}
                            </div>
                            <div className="tab-btn" onClick={() => handleActive("hourly")}>
                                {" "}
                                Hourly{" "}
                            </div>
                            <div className="tab-btn" onClick={() => handleActive("daily")}>
                                {" "}
                                Daily{" "}
                            </div>
                            <div className="tab-btn" onClick={() => handleActive("airquality")}>
                                {" "}
                                Airquality{" "}
                            </div>
                            {/* <div className="tab-btn" onClick={() => handleActive('radar')}> Radar </div> */}
                            {/* <div className="tab-btn" onClick={() => handleActive('news')}> News </div> */}
                            <div className="tab-btn" onClick={() => handleActive("alert")}>
                                {" "}
                                Alerts{" "}
                                <Badge style={{ marginLeft: "2px" }} variant="danger">
                                    {alertData?.length ?? 0}
                                </Badge>{" "}
                            </div>
                        </Row>
                        <hr />
                        {ok ? (
                            <Container>
                                {isNowActive ? <NowTab data={data} /> : <div></div>}
                                {isHourlyActive ? <HourlyTab data={data} /> : <div></div>}
                                {isDailyActive ? <DailyTab data={data} /> : <div></div>}
                                {isAirqualityActive ? <AirqualityTab data={airData} /> : <div></div>}
                                {/* {isRadarActive ? <RadarTab data={data}/> : <div></div>} */}
                                {/* {isNewsActive ? <NewsTab data={data}/> : <div></div>} */}
                                {isAlertsActive ? <AlertsTab alerts={alertData} /> : <div></div>}
                            </Container>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </Container>
            </div>
        </div>
    );
}
